import { Currency } from '@/core/currency/interfaces';

const MWK: Currency = {
    name: 'Malawian Kwacha',
    demonym: 'Malawian',
    majorSingle: 'Kwacha',
    majorPlural: 'Kwacha',
    codeNumeric: '454',
    symbol: 'MK',
    symbolNative: 'MK',
    minorSingle: 'Tambala',
    minorPlural: 'Tambala',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'MWK',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default MWK;
